// eslint-disable-next-line react/react-in-jsx-scope
import React from 'react';
import GameRulesText from '../../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray', margin: '0' }}>
      <GameRulesText game="recognizeEasy" />
    </p>
  </>
);

export default RulesOfTheGame;
